module.exports = __webpack_public_path__ + "media/video503.62d40935.mp4";